module.exports = __webpack_public_path__ + "assets/colours.20039b2f.svg";